import React, { useEffect, useState } from 'react';
import "../../assets/styles/EditStore/EditStore.css";
import TopBar from "../../components/EditStoreComponents/EditStoreTopBar";
import SliderBox from "../../components/EditStoreComponents/EditStoreSlider";
import EditStoreOption from "../../components/EditStoreComponents/EditStoreOption";
import EditStoreTopProduct from "../../components/EditStoreComponents/EditStoreTopProduct";
import EditStoreFooter from "../../components/EditStoreComponents/EditStoreFooter";
import SliderSection from '../../components/EditStoreComponents/SliderSection'
import FavoritSections from '../../components/EditStoreComponents/FavoritSections'
import {baseURL} from "../../js/Axios/Axios";
export default function EditStore() {
  const [theme_type, setTheme_type] = useState(0);
  const [custome, setcustome] = useState(true);
  const [btn, setbtn] = useState(true);
  const fetchData = async () => {
    try {
      // Check if the token exists in the local storage
      const token = localStorage.getItem('access_token');
      // Fetch the data using the stored token
      const dataResponse = await fetch(`${baseURL}/Store/showInfo`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!dataResponse.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await dataResponse.json();
      console.log('resssss', data.data.theme_type)
      setTheme_type(data.data.theme_type);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // Function to fetch the data from the API
    fetchData();
  }, []);

  if (!theme_type) {
    return <div className='text-center font-bold mt-10 w-full'>لطفا منتظر بمانید</div>;
  }


  return (
    <>
      {theme_type == 1 && <div className="Edit-store-all">
        <div className="Edit-Store-header">
          <TopBar theme_type={theme_type} />
        </div>
        <div className="Edit-Store-slider">
          <SliderBox />
        </div>
        <div className="Edit-Store-Option">
          <EditStoreOption />
        </div>
        <div className="Edit-Store-top-product">
          <EditStoreTopProduct number={3} />
        </div>
        <div className="Edit-Store-footer">
          <EditStoreFooter />
        </div>
      </div>}
      {theme_type == 2 && <div className="Edit-store-all max-w-7xl mx-auto">
        <div className="Edit-Store-header">
          <TopBar theme_type={theme_type} />
        </div>
        <div className='w-full'>
          <SliderSection />
        </div>
        <div className='flex items-center gap-2 flex-nowrap w-full justify-center'>
          <h1 className='py-10 text-2xl'>بنر های بالای صفحه</h1>
          <p className='h-1 w-10/12 bg-00589c'></p>
        </div>
        <div className='flex items-center gap-5 w-full mt-5'>
          <div className="w-1-2 rounded-lg">
            <EditStoreTopProduct btn={btn} number={1} />
            <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 502  و طول 210 پیکسل باشد</p>
          </div>
          <div className="w-1-2 rounded-lg">
            <EditStoreTopProduct btn={btn} number={2} />
            <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 502  و طول 210 پیکسل باشد</p>
          </div>
        </div>
        <div className='flex items-center gap-5 w-full mt-5'>
          <div className="w-1-2 rounded-lg">
            <EditStoreTopProduct btn={btn} number={3} />
            <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 502  و طول 210 پیکسل باشد</p>
          </div>
          <div className="w-1-2 rounded-lg">
            <EditStoreTopProduct btn={btn} number={4} />
            <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 502  و طول 210 پیکسل باشد</p>
          </div>
        </div>
        <div className='w-full'>
          <div className='flex items-center gap-2 flex-nowrap'>
            <h1 className='py-10 text-xl'>دسته بندی های محبوب</h1>
          </div>
          <FavoritSections />
        </div>
        <div className='flex items-center gap-2 flex-nowrap w-full'>
          <h1 className='py-10 text-2xl'>بنر های پایین صفحه</h1>
        </div>
        <div className='grid grid-cols-2 gap-4 w-full'>
          <div className="Edit-Store-top-product h-full w-full">
          <div>
            <EditStoreTopProduct custome={custome} btn={btn} number={5} />

            <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 592  و طول 394 پیکسل باشد</p>

            </div>
          </div>
          <div className='flex flex-col h-full'>
            <div className="Edit-Store-top-product h-full">
              <div>
              <EditStoreTopProduct btn={btn} number={6} />
              <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 592  و طول 189 پیکسل باشد</p>
              </div>
            </div>
            <div className="Edit-Store-top-product">
              <div>
              <EditStoreTopProduct btn={btn} number={7} />
              <p className="tips"> اندازه بنر برای رابط کاربری دقیق تر باید در عرض 592  و طول 189 پیکسل باشد</p>
              </div>
            </div>
          </div>
        </div>
        <div className="Edit-Store-footer">
          <EditStoreFooter btn={btn} />
        </div>
      </div>
      }
    </>
  );
}
